import { MachineFailureCategory } from "@/services/repository/machines"

const sessionKey = 'new_failure_'

export enum FailureType {

}

export interface FailureForm {
  symptoms: Set<string>
}

export interface Failure {
  category: MachineFailureCategory | undefined
  description: string
  galleryId: string | undefined
  form: FailureForm
}

const ID = (machineId: string): string => {
  return sessionKey+machineId
}

export const LoadFailure = (machineId: string): Failure => {
  var json = sessionStorage.getItem(ID(machineId))
  if(!json) {
    return CleanFailure(machineId)
  }
  const data = JSON.parse(json)
  return {
    category: data.category,
    description: data.description,
    galleryId: data.galleryId,
    form: {
      symptoms: new Set<string>(Array.from(data.form?.symptoms))
    }
  }
}

export const SaveFailure = (machineId: string, failure: Failure) => {
  sessionStorage.setItem(ID(machineId), JSON.stringify({
    category: failure.category,
    description: failure.description,
    galleryId: failure.galleryId,
    form: {
      symptoms: Array.from(failure.form.symptoms)
    }
  }))
}
 
export const CleanFailure = (machineId: string): Failure => {
  var empty: Failure = {
    category: undefined,
    description: '',
    galleryId: undefined,
    form: {
      symptoms: new Set<string>()
    },
  }
  SaveFailure(machineId, empty)
  return empty
}